import { createContext, useContext } from 'react';
import { useHealth } from '../hooks/useHealth';

const HealthContext = createContext({}); // Initialize with empty object instead of null

export const HealthProvider = ({ children }) => {
  const health = useHealth();
  // Ensure we provide a default object even if health is loading/null
  return (
    <HealthContext.Provider value={health || {}}>
      {children}
    </HealthContext.Provider>
  );
};

export const useHealthContext = () => useContext(HealthContext);